/**
 * Origem, modo e janela do projeto (#1784).
 *
 * Os três são definidos na criação. Origem e modo travam na primeira carga do ex-kit; a janela
 * muda a qualquer hora e vale para a próxima extração e o próximo Functional.
 *
 * Quais áreas a origem não tem é decisão do backend (`unavailable_areas` no projeto, de
 * `project_source.py`): a tela só consulta, para a regra morar num lugar só.
 */

import type { Project } from "@/types/api";

export const SOURCE_TYPES = ["ecc", "s4hana", "business_one", "other"] as const;
export type SourceType = (typeof SOURCE_TYPES)[number];

export const PROJECT_MODES = ["presale", "migration"] as const;
export type ProjectMode = (typeof PROJECT_MODES)[number];

/** A faixa que o formulário do Functional aceitava antes da janela ir para o projeto. */
export const WINDOW_MIN_MONTHS = 1;
export const WINDOW_MAX_MONTHS = 240;
export const WINDOW_DEFAULT_MONTHS = 36;

/** As áreas que só existem para origem SAP (modelo de domínio, P6). */
export type ProjectArea = "architect" | "configuration_server" | "code_companion" | "adherence";

/** Chaves de i18n dos rótulos; o texto em inglês é a própria chave. */
export const SOURCE_TYPE_LABEL: Record<SourceType, string> = {
  ecc: "SAP ECC",
  s4hana: "SAP S/4HANA",
  business_one: "SAP Business One",
  other: "Other ERP",
};

export const PROJECT_MODE_LABEL: Record<ProjectMode, string> = {
  presale: "Pre-sale",
  migration: "Migration",
};

/**
 * Se o projeto tem a área. Projeto ainda não carregado tem todas: esconder enquanto a resposta
 * não volta faria o bloco piscar em todo projeto SAP, que é quase todo projeto de hoje.
 */
export function isAreaAvailable(
  project: Pick<Project, "unavailable_areas"> | null | undefined,
  area: ProjectArea,
): boolean {
  return !(project?.unavailable_areas ?? []).includes(area);
}

export function windowMonthsIsValid(value: number): boolean {
  return Number.isInteger(value) && value >= WINDOW_MIN_MONTHS && value <= WINDOW_MAX_MONTHS;
}
